import React, { useState, useEffect, useContext } from "react";
import "./reviewModalv2.scss";
import Button from "@mui/material/Button";
import { Link } from "react-router-dom";
import { withTranslation, useTranslation } from "react-i18next";
import Axios from "axios";
// External Components
import Backdrop from "@mui/material/Backdrop";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import Rating from "@mui/material/Rating";
import { TextareaAutosize } from "@material-ui/core";
// import {handleCustomerReview} from "../../../../redux-store/action"
import LoaderAnimation from "../LoaderAnimation";
// Context api calling
import StateContext from "../../StateContext";
// Axios
import axios from "axios";
import DispatchContext from "../../DispatchContext";
import { handleError } from "../../Functions/getAlert";
import { handleGoogleReview } from "../../Functions/googleReview";
import { id } from "date-fns/locale";
import { get_lang } from "../../Functions/getLang";
import { Skeleton } from "@mui/material";
import vendorsConfig from "../../vendorsConfig";
function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const ReviewModalv2 = ({ storeInfo, invoiceDetail }) => {
  const { t } = useTranslation();
  const appState = useContext(StateContext);
  const appDispatch = useContext(DispatchContext);
  const [fullWidth] = React.useState(true);
  const [maxWidth] = React.useState("lg");
  const [value, setValue] = useState(5);
  const [alertMessage, setAlertMessage] = useState({
    open: false,
    message: "",
  });
  const [review, setReview] = useState("");
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const starStyle = {
    width: 30,
    height: 30,
    padding: 100,
    color: "green",
  };
  const [reviewData, setReviewData] = useState([]);
  const [reviewAnswer, setReviewAnswer] = useState([]);
  const s = [
    {
      id: 1,
      question: { en: "What is your overall experience with us?", ar: "" },
      options: [
        {
          id: 1,
          answer: { en: "Good", ar: "" },
        },
        {
          id: 2,
          answer: { en: "Bad", ar: "" },
        },
        {
          id: 3,
          answer: { en: "Average", ar: "" },
        },
      ],
    },
    {
      id: 2,
      question: { en: "What is your overall experience with us?", ar: "" },
      options: [
        {
          id: 6,
          answer: { en: "Good", ar: "" },
        },
        {
          id: 12,
          answer: { en: "Bad", ar: "" },
        },
        {
          id: 33,
          answer: { en: "Average", ar: "" },
        },
        {
          id: 44,
          answer: { en: "Averag2e", ar: "" },
        },
      ],
    },
  ];
  const [checked, setChecked] = React.useState(true);

  const handleSetReviewAnswer = (questionId, answerId) => {
    setReviewAnswer((prevAnswers) => {
      // Check if the same answer is already selected
      const isSelected = prevAnswers.some(
        (ans) => ans.question_id === questionId && ans.answer_id === answerId
      );
  
      if (isSelected) {
        // If already selected, remove it
        return prevAnswers.filter(
          (ans) => !(ans.question_id === questionId && ans.answer_id === answerId)
        );
      } else {
        // Otherwise, replace any existing answer for the question and add the new one
        const updatedAnswers = prevAnswers.filter(
          (ans) => ans.question_id !== questionId
        );
        return [...updatedAnswers, { question_id: questionId, answer_id: answerId }];
      }
    });
  };
  
  
  const handleClose = () => {
    appDispatch({
      type: "setReviewModal",
      reviewModal: false,
    });
  };
  const handleGetReviewQuestions = async () => {
    setIsLoading(true);
    //
    try {
      const response = await Axios.get(
        `${process.env.REACT_APP_API_URL}rating/question?status=1&branch=${storeInfo?.branch_id}`
      );

      if (response.data.success) {
        const questions = response.data.data || [];

        // Map questions with their answers in one loop
        const filteredQuestions = questions
          .filter((question) => question.status) // Filter active questions
          .map((question) => ({
            id: question.id,
            question: question.question,
            options: question.answers
              .filter((answer) => answer.status) // Filter active answers
              .map((answer) => ({
                id: answer.id,
                answer: answer.answer,
              })),
          }));

        setReviewData(filteredQuestions);
      } else {
        setReviewData([]);
      }
    } catch (e) {
      handleError(e, appDispatch);
      setAlertMessage({
        open: true,
        message: e.message || "Something went wrong",
        alertSuccess: false,
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const formData = new FormData();

      // Append the necessary fields to the FormData object
      formData.append("invoice_id", invoiceDetail.id);
      formData.append("rating", value ? value : 1);
      formData.append("review", review);

      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}rating/add`,
        formData
      );

      if (res.data.success === true) {
        if (reviewData.length > 0) {
          let reviewAns = {
            invoice_id: invoiceDetail.id,
            reviews: reviewAnswer
          }
          const res2 = await axios.post(
            `${process.env.REACT_APP_API_URL}rating/answer/customer`,
            reviewAns,
            {
              headers: {
                Authorization: `Bearer ${appState.token}`,
              },
            }
          );

          if (res2.data.success === true) {
          } else {
            setAlertMessage({
              open: true,
              message: res.data.message,
              alertSuccess: false,
            });
            setOpen(false);
            setLoading(false);
          }
        }

        setAlertMessage({
          open: true,
          message: res.data.message,
          alertSuccess: true,
        });
        setOpen(false);
        setLoading(false);
        setReview("");
        appDispatch({
          type: "setReviewModal",
          reviewModal: false,
        });
        if (storeInfo.rating_id != null && value == 5) {
          handleGoogleReview(storeInfo, invoiceDetail, value);
        }
      } else {
        setAlertMessage({
          open: true,
          message: res.data.message,
          alertSuccess: false,
        });
        setLoading(false);
        setReview("");
      }
    } catch (e) {
      Promise.reject(e);
      if (e.response.status === 401) {
      }
      handleError(e, appDispatch);
      setLoading(false);
    }
  };

  const handleReview = (e) => {
    setReview(e.target.value);
  };

  function getLabelText(value) {
    return `${value} Star${value !== 1 ? "s" : ""}, ${labels[value]}`;
  }
  const [hover] = React.useState(-1);
  const labels = {
    0: "wao",
    1: "Terrible",
    2: "Bad",
    3: "Ok",
    4: "Good",
    5: "Great",
  };

  useEffect(() => {
    if (!invoiceDetail.isReviewed && invoiceDetail.status === "Paid") {
      setOpen(true);
    }
    handleGetReviewQuestions();
  }, []);

  useEffect(() => {
    setTimeout(
      () => setAlertMessage({ open: false, message: "", alertSuccess: false }),
      8000
    );
  }, [alertMessage.open]);

  return (
    <>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={alertMessage.open}
        className={alertMessage.alertSuccess ? "success-alert" : "danger-alert"}
      >
        {alertMessage.alertSuccess ? (
          <Alert severity="success">{alertMessage.message}</Alert>
        ) : (
          <Alert severity="error">{alertMessage.message}</Alert>
        )}
      </Snackbar>
      {loading && (
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 2 }}
          open={loading}
        >
          <LoaderAnimation />
        </Backdrop>
      )}

      <div
        className="reviewModalv2-backdrop"
        onClick={handleClose}
        aria-hidden="true"
      />

      <div
        id="mySidenav"
        className={`px-3 reviewModalv2l1 ${
          appState.langValue == "ar" ? "reviewModalv2l1Arabic" : ""
        }`}
        style={reviewData.length > 0 ? { height: "750px" } : {}}
        role="dialog"
        aria-modal="true"
        onClick={(e) => e.stopPropagation()}
      >
        <button type="button" className="closebtn" onClick={handleClose} aria-label="Close">
          &times;
        </button>

        <div
          className={`${appState.langValue === "ar" ? "directionRtl" : ""}`}
          id="reviewModalMainl1"
        >
          {/* <IconButton className="ml-auto my-1 d-flex" onClick={handleClose}>
            <CloseIcon />
          </IconButton> */}
          <h1 className="text-center mt-5 px-2">
            {" "}
            {t("Review.How-was-your-experience")} {storeInfo.businessName}?
          </h1>
          <div className="px-1">
            <div className="container-fluid mt-3">
              <div className="row d-flex justify-content-center store-tilte-card py-2">
                <div className="col-md-2 col-6 px-0 d-flex justify-content-center  align-items-center">
                  <Link to="/">
                    <div className="imgDiv  d-flex align-items-center w-100  px-1">
                      <img
                        src={
                          storeInfo.logo
                            ? `${storeInfo.logo}`
                            : `https://qs.${vendorsConfig.SLUG}.dev/storage/app/public/stores/logo/no_image_logo.png`
                        }
                        className="w-100 rounded h-100 img-fluid"
                        alt=""
                      />
                    </div>
                  </Link>
                </div>
              </div>
            </div>
            <div className="container-fluid px-0">
              <h3
                className={`familyManrope800 mt-2 ${
                  appState.langValue === "ar" ? "text-center" : "text-center"
                }`}
              >
                {t("Review.Rate-the-experience")}:
              </h3>
              <div className="row mt-2">
                <div className="col-12 d-flex justify-content-center ">
                  <Rating
                    name="size-medium"
                    defaultValue={4}
                    value={value}
                    getLabelText={getLabelText}
                    onChange={(event, newValue) => {
                      setValue(newValue);
                    }}
                    size="medium"
                    itemStyle={starStyle}
                  />
                </div>
                <div className="col-12 d-flex align-items-center justify-content-center">
                  {value !== null && (
                    <h4 className="familyManrope800">
                      {labels[hover !== -1 ? hover : value]}
                    </h4>
                  )}
                  {value == null && <h4>&nbsp;</h4>}
                </div>
              </div>
              <div className="addInstructions  py-md-2">
                <p
                  className={`familyManrope800 textBlack pt-md-2 pb-1 ${
                    appState.langValue === "ar" ? "text-right" : "text-left"
                  }`}
                >
                  {t("Review.Can-you-share-your-thought-about-the-experience")}
                </p>
                <TextareaAutosize
                  className="textArea familyManrope800"
                  aria-label="minimum height"
                  width="100%"
                  minRows={5}
                  maxRows={4}
                  placeholder={t("Review.Your-Comment-(Optional)")}
                  onChange={handleReview}
                />
              </div>
              {isLoading
                ? [1, 3].map((item, index) => (
                    <>
                      <div className="col-10 p-0" key={index}>
                        <Skeleton
                          variant="rectangular"
                          width={"100%"}
                          height={30}
                          sx={{ borderRadius: "8px" }}
                        />
                      </div>
                      <div className="row p-0">
                        {[1, 2, 3].map((item, index) => (
                          <div className="col-3 mx-1 py-2" key={index}>
                            <Skeleton
                              variant="rectangular"
                              width={"100%"}
                              height={40}
                              sx={{ borderRadius: "8px" }}
                            />
                          </div>
                        ))}
                      </div>
                    </>
                  ))
                : reviewData.length > 0 &&
                  reviewData.map((item, index) => (
                    <div className="addInstructions  pb-2" key={index}>
                      <p
                        className={`familyManrope800 textBlack pt-md-2 m-0 ${
                          appState.langValue === "ar"
                            ? "text-right"
                            : "text-left"
                        }`}
                      >
                        {get_lang(item.question, appState.langValue)}
                      </p>
                      <div className="d-flex align-items-center flex-wrap pb-1 ">
                        {item.options.map((item2, index) => (
                          <div
                            key={index}
                            className={`p-1   ${
                              reviewAnswer.some(
                                (ans) =>
                                  ans.question_id === item.id &&
                                  ans.answer_id === item2.id
                              )
                                ? "active-btn-review"
                                : "non-active-btn-review"
                            }`}
                            style={{ width: "auto" }}
                          >
                            <Button
                              className={`  `}
                              onClick={() =>
                                handleSetReviewAnswer(item.id, item2.id)
                              }
                            >
                              {get_lang(item2.answer, appState.langValue)}
                            </Button>
                          </div>
                        ))}
                      </div>
                    </div>
                  ))}
                  <div className="bottomFixedBtn">
                <div className="row mx-0 d-flex justify-content-center pb-1 pt-2 submitBtn col-md-12">
                  <Button
                    className=" col-md-12 blackBtn py-3 text-capitalized"
                    onClick={handleSubmit}
                    disabled={loading}
                  >
                    {t("Review.submit")}
                  </Button>
                </div>

                <div className="d-flex justify-content-center ">
                    <Button onClick={handleClose} className="col-md-12">
                      <p
                        onClick={handleClose}
                        className="text-center cursorPointer color-primary familyManrope800 col-md-12"
                      >
                        {t("Review.Skip")}
                      </p>
                    </Button>
                </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default withTranslation()(ReviewModalv2);
